import React from "react";

const SpinnerButton = () => {
  return (
    <div className="spinner-btn">
      <div className="spin-btn center-vertically"></div>
    </div>
  );
};

export default SpinnerButton;
